import "./discussion-item.css";
import { BsCheck2, BsCheck2All } from "react-icons/bs";
import {
  capitalizeAll,
  formatMessageDate,
  truncateValue,
} from "../../../../core/utils/helpers";

const DiscussionItem = ({ data, onAction }) => {
  const _profile = data?.thumbnail;
  const _usernames = capitalizeAll(`${data?.firstname} ${data?.lastname}`);
  const _last_dates = data?.last_dates;
  const _message = data?.last_message;
  const _status = data?.last_status;
  const _total_messages_no_read = data?.total_messages_no_read;
  const _i_am_sender = data?.i_am_sender;

  return (
    <div className="discussion-item" onClick={() => onAction()}>
      <img src={process.env.PUBLIC_URL + "/user.png"} alt="user profile" />
      <div className="discussion-item-description">
        <div className="discussion-up">
          <h1>{_usernames}</h1>
          <span>{formatMessageDate(_last_dates)}</span>
        </div>
        <div className="discussion-bottom">
          <div className="discussion-text">
            {_i_am_sender && _status === "sent" && (
              <BsCheck2 className="icon" />
            )}
            {_i_am_sender && _status === "delivered" && (
              <BsCheck2All className="icon" />
            )}
            {_i_am_sender && _status === "read" && (
              <BsCheck2All className="icon is-read" />
            )}
            <p>{truncateValue(_message, 37)}</p>
          </div>
          {_total_messages_no_read > 0 && (
            <span>{_total_messages_no_read}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default DiscussionItem;
